<template>
  <main class="product-single">
    <Header />

    <section class="hero bg-sectionbg">
      <div class="hero-content xl:py-spc5 md:py-10">
        <div class="container">
          <h1
            class="xl:text-size2 font-bold text-secondary leading-spc4 md:text-size9"
          >Made Jekyll theme</h1>
          <p
            class="xl:text-size3 md:text-size12 text-paragraph leading-spc3 tracking-spc2 mt-spc4 font-medium"
          >
            Show off your best work with this beautiful, minimal and customizable
            portfolio theme made for designers and developers.
          </p>
        </div>
      </div>
    </section>

    <section class="gallery-wrapper xl:pb-spc5 pb-spc5 md:pb-10 bg-sectionbg">
      <div class="container">
        <carousel
          class="gallery-slider xl:w-4/5"
          :autoplay="false"
          :autoHeight="true"
          :items="1"
          :margin="20"
          :dots="true"
          :loop="true"
          :nav="false"
        >
          <div class="item relative">
            <div class="theme-screenshot relative">
              <div class="theme-browser bg-whitelight2 h-6 flex items-center pl-2">
                <span class="bg-white rounded-full w-2 h-2 mr-spc8"></span>
                <span class="bg-white rounded-full w-2 h-2 mr-spc8"></span>
                <span class="bg-white rounded-full w-2 h-2 mr-spc8"></span>
              </div>
              <img :src="require('@/assets/images/pt-single-1.jpg')" alt="Theme" />
            </div>
          </div>
          <div class="item relative">
            <div class="theme-screenshot relative">
              <div class="theme-browser bg-whitelight2 h-6 flex items-center pl-2">
                <span class="bg-white rounded-full w-2 h-2 mr-spc8"></span>
                <span class="bg-white rounded-full w-2 h-2 mr-spc8"></span>
                <span class="bg-white rounded-full w-2 h-2 mr-spc8"></span>
              </div>
              <img :src="require('@/assets/images/pt-single-2.jpg')" alt="Theme" />
            </div>
          </div>
          <div class="item relative">
            <div class="theme-screenshot relative">
              <div class="theme-browser bg-whitelight2 h-6 flex items-center pl-2">
                <span class="bg-white rounded-full w-2 h-2 mr-spc8"></span>
                <span class="bg-white rounded-full w-2 h-2 mr-spc8"></span>
                <span class="bg-white rounded-full w-2 h-2 mr-spc8"></span>
              </div>
              <img :src="require('@/assets/images/pt-single-3.jpg')" alt="Theme" />
            </div>
          </div>
          <div class="item relative">
            <div class="theme-screenshot relative">
              <div class="theme-browser bg-whitelight2 h-6 flex items-center pl-2">
                <span class="bg-white rounded-full w-2 h-2 mr-spc8"></span>
                <span class="bg-white rounded-full w-2 h-2 mr-spc8"></span>
                <span class="bg-white rounded-full w-2 h-2 mr-spc8"></span>
              </div>
              <img :src="require('@/assets/images/pt-single-4.jpg')" alt="Theme" />
            </div>
          </div>
          <div class="item relative">
            <div class="theme-screenshot relative">
              <div class="theme-browser bg-whitelight2 h-6 flex items-center pl-2">
                <span class="bg-white rounded-full w-2 h-2 mr-spc8"></span>
                <span class="bg-white rounded-full w-2 h-2 mr-spc8"></span>
                <span class="bg-white rounded-full w-2 h-2 mr-spc8"></span>
              </div>
              <img :src="require('@/assets/images/pt-single-5.jpg')" alt="Theme" />
            </div>
          </div>
          <div class="item relative">
            <div class="theme-screenshot relative">
              <div class="theme-browser bg-whitelight2 h-6 flex items-center pl-2">
                <span class="bg-white rounded-full w-2 h-2 mr-spc8"></span>
                <span class="bg-white rounded-full w-2 h-2 mr-spc8"></span>
                <span class="bg-white rounded-full w-2 h-2 mr-spc8"></span>
              </div>
              <img :src="require('@/assets/images/pt-single-6.jpg')" alt="Theme" />
            </div>
          </div>
        </carousel>
      </div>
    </section>

    <section class="theme-details-wrap bg-sectionbg xl:pb-spc5 pb-spc5 md:pb-10">
      <div class="container p-0">
        <div class="theme-details-content flex xl:flex-row flex-row md:flex-col">
          <div
            class="column theme-content-main xl:px-spc7 px-spc7 md:px-5 xl:w-2/3 w-2/3 md:w-full xl:order-1 order-1 md:order-2 xl:mt-0 md:mt-10"
          >
            <div
              class="theme-content-wrap xl:pt-spc16 pt-spc16 xl:px-spc17 px-spc17 xl:pb-spc17 pb-spc17 md:pt-spc20 md:pr-10 md:pb-10 md:pl-10 bg-white"
            >
              <h1
                class="xl:text-size4 text-size4 md:text-3xl font-bold text-secondary leading-spc4"
              >A bold, minimal portfolio theme</h1>
              <p
                class="xl:text-size11 text-size11 md:text-xl leading-spc3 text-paragraph font-medium mt-4 mb-spc18 tracking-spc2"
              >Made is the perfect Jekyll theme for designers, web developers and other creatives to build an awesome personal portfolio website. Show off your best work and your blog posts in a great modern style.</p>
              <h3 id="features" class="text-size6 font-bold text-secondary mb-3">Features</h3>
              <p
                class="bottom-desc xl:text-size5 text-size5 font-medium leading-spc3 text-paragraph tracking-spc2 md:text-size8"
              >Made is full of powerful features to help showcase your work:</p>
              <ul class="theme-features my-10">
                <li class="p-spc4">
                  <h3 class="flex items-center text-xl font-bold">
                    <span class="icon">
                      <svg
                        class="svg-inline--fa w-5 mr-3 text-primary fa-grin-hearts fa-w-16"
                        aria-hidden="true"
                        data-prefix="far"
                        data-icon="grin-hearts"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 496 512"
                        data-fa-i2svg
                      >
                        <path
                          fill="currentColor"
                          d="M353.6 304.6c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-152.8-48.9c4.5 1.2 9.2-1.5 10.5-6l19.4-69.9c5.6-20.3-7.4-41.1-28.8-44.5-18.6-3-36.4 9.8-41.5 27.9l-2 7.1-7.1-1.9c-18.2-4.7-38.2 4.3-44.9 22-7.7 20.2 3.8 41.9 24.2 47.2l70.2 18.1zm188.8-65.3c-6.7-17.6-26.7-26.7-44.9-22l-7.1 1.9-2-7.1c-5-18.1-22.8-30.9-41.5-27.9-21.4 3.4-34.4 24.2-28.8 44.5l19.4 69.9c1.2 4.5 5.9 7.2 10.5 6l70.2-18.2c20.4-5.3 31.9-26.9 24.2-47.1zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200z"
                        />
                      </svg>
                    </span> Beautiful, minimal design
                  </h3>
                  <p
                    class="text-size8 text-paragraph leading-spc3 font-medium mt-spc19 tracking-spc2"
                  >Made has been designed to put your content first, with a stylish and minimal interface to make navigation easy.</p>
                </li>
                <li class="p-spc4">
                  <h3 class="flex items-center text-xl font-bold">
                    <span class="icon">
                      <svg
                        class="svg-inline--fa w-4 mr-3 text-primary fa-file-alt fa-w-12"
                        aria-hidden="true"
                        data-prefix="far"
                        data-icon="file-alt"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 384 512"
                        data-fa-i2svg
                      >
                        <path
                          fill="currentColor"
                          d="M288 248v28c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm-12 72H108c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-28c0-6.6-5.4-12-12-12zm108-188.1V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h204.1C264.8 0 277 5.1 286 14.1L369.9 98c9 8.9 14.1 21.2 14.1 33.9zm-128-80V128h76.1L256 51.9zM336 464V176H232c-13.3 0-24-10.7-24-24V48H48v416h288z"
                        />
                      </svg>
                    </span> Flexible layout
                  </h3>
                  <p
                    class="text-size8 text-paragraph leading-spc3 font-medium mt-spc19 tracking-spc2"
                  >Your portfolio gets plenty of screen real-estate with a full width image carousel. Blog posts are arranged neatly in a flexible grid.</p>
                </li>
                <li class="p-spc4">
                  <h3 class="flex items-center text-xl font-bold">
                    <span class="icon">
                      <svg
                        class="svg-inline--fa w-3 mr-3 text-primary fa-mobile-alt fa-w-10"
                        aria-hidden="true"
                        data-prefix="far"
                        data-icon="mobile-alt"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320 512"
                        data-fa-i2svg
                      >
                        <path
                          fill="currentColor"
                          d="M192 416c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm48-60V92c0-6.6-5.4-12-12-12H92c-6.6 0-12 5.4-12 12v264c0 6.6 5.4 12 12 12h136c6.6 0 12-5.4 12-12zm80-308v416c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h224c26.5 0 48 21.5 48 48zm-48 410V54c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v404c0 3.3 2.7 6 6 6h212c3.3 0 6-2.7 6-6z"
                        />
                      </svg>
                    </span> Responsive design
                  </h3>
                  <p
                    class="text-size8 text-paragraph leading-spc3 font-medium mt-spc19 tracking-spc2"
                  >Made works perfectly on all devices, adapting the layout to fit best with whatever screen size it's viewed on.</p>
                </li>
                <li class="p-spc4">
                  <h3 class="flex items-center text-xl font-bold">
                    <span class="icon">
                      <svg
                        class="svg-inline--fa w-6 mr-3 text-primary fa-images fa-w-18"
                        aria-hidden="true"
                        data-prefix="far"
                        data-icon="images"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                        data-fa-i2svg
                      >
                        <path
                          fill="currentColor"
                          d="M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v48H54a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6v-10h48zm42-336H150a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6V86a6 6 0 0 0-6-6zm6-48c26.51 0 48 21.49 48 48v256c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h384zM264 144c0 22.091-17.909 40-40 40s-40-17.909-40-40 17.909-40 40-40 40 17.909 40 40zm-72 96l39.515-39.515c4.686-4.686 12.284-4.686 16.971 0L288 240l103.515-103.515c4.686-4.686 12.284-4.686 16.971 0L480 208v80H192v-48z"
                        />
                      </svg>
                    </span> Portfolio post type
                  </h3>
                  <p
                    class="text-size8 text-paragraph leading-spc3 font-medium mt-spc19 tracking-spc2"
                  >A dedicated post type for your portfolio items, helping you to keep things organized. Add a custom accent color for that extra special polish!</p>
                </li>
                <li class="p-spc4">
                  <h3 class="flex items-center text-xl font-bold">
                    <span class="icon">
                      <svg
                        class="svg-inline--fa w-4 mr-3 text-primary fa-align-left fa-w-14"
                        aria-hidden="true"
                        data-prefix="far"
                        data-icon="align-left"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                        data-fa-i2svg
                      >
                        <path
                          fill="currentColor"
                          d="M288 48v32c0 6.627-5.373 12-12 12H12C5.373 92 0 86.627 0 80V48c0-6.627 5.373-12 12-12h264c6.627 0 12 5.373 12 12zM12 220h424c6.627 0 12-5.373 12-12v-32c0-6.627-5.373-12-12-12H12c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12zm0 256h424c6.627 0 12-5.373 12-12v-32c0-6.627-5.373-12-12-12H12c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12zm264-184H12c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h264c6.627 0 12-5.373 12-12v-32c0-6.627-5.373-12-12-12z"
                        />
                      </svg>
                    </span> Blog section
                  </h3>
                  <p
                    class="text-size8 text-paragraph leading-spc3 font-medium mt-spc19 tracking-spc2"
                  >Made includes a dedicated section for your blog, with simple pagination and your latest post featured front and center.</p>
                </li>
                <li class="p-spc4">
                  <h3 class="flex items-center text-xl font-bold">
                    <span class="icon">
                      <svg
                        class="svg-inline--fa w-5 mr-3 text-primary fa-sync fa-w-16"
                        aria-hidden="true"
                        data-prefix="far"
                        data-icon="sync"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        data-fa-i2svg
                      >
                        <path
                          fill="currentColor"
                          d="M500 8h-27.711c-6.739 0-12.157 5.548-11.997 12.286l2.347 98.575C418.212 52.043 342.256 8 256 8 134.813 8 33.933 94.924 12.296 209.824 10.908 217.193 16.604 224 24.103 224h28.576c5.674 0 10.542-3.982 11.737-9.529C83.441 126.128 161.917 60 256 60c79.545 0 147.942 47.282 178.676 115.302l-126.39-3.009c-6.737-.16-12.286 5.257-12.286 11.997V212c0 6.627 5.373 12 12 12h192c6.627 0 12-5.373 12-12V20c0-6.627-5.373-12-12-12zm-12.103 280h-28.576c-5.674 0-10.542 3.982-11.737 9.529C428.559 385.872 350.083 452 256 452c-79.546 0-147.942-47.282-178.676-115.302l126.39 3.009c6.737.16 12.286-5.257 12.286-11.997V300c0-6.627-5.373-12-12-12H12c-6.627 0-12 5.373-12 12v192c0 6.627 5.373 12 12 12h27.711c6.739 0 12.157-5.548 11.997-12.286l-2.347-98.575C93.788 459.957 169.744 504 256 504c121.187 0 222.067-86.924 243.704-201.824 1.388-7.369-4.308-14.176-11.807-14.176z"
                        />
                      </svg>
                    </span> Ajax navigation
                  </h3>
                  <p
                    class="text-size8 text-paragraph leading-spc3 font-medium mt-spc19 tracking-spc2"
                  >The sleek Ajax navigation and page transitions help give that 'premium' feel that your site deserves.</p>
                </li>
                <li class="p-spc4">
                  <h3 class="flex items-center text-xl font-bold">
                    <span class="icon">
                      <svg
                        class="svg-inline--fa w-5 mr-3 text-primary fa-eye fa-w-18"
                        aria-hidden="true"
                        data-prefix="far"
                        data-icon="eye"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                        data-fa-i2svg
                      >
                        <path
                          fill="currentColor"
                          d="M569.354 231.631C512.97 135.949 407.81 72 288 72 168.14 72 63.004 135.994 6.646 231.631a47.999 47.999 0 0 0 0 48.739C63.031 376.051 168.19 440 288 440c119.86 0 224.996-63.994 281.354-159.631a47.997 47.997 0 0 0 0-48.738zM288 392c-102.556 0-192.091-54.701-240-136 44.157-74.933 123.677-127.27 216.162-135.007C273.958 131.078 280 144.83 280 160c0 30.928-25.072 56-56 56s-56-25.072-56-56l.001-.042C157.794 179.043 152 200.844 152 224c0 75.111 60.889 136 136 136s136-60.889 136-136c0-31.031-10.4-59.629-27.895-82.515C451.704 164.638 498.009 205.106 528 256c-47.908 81.299-137.444 136-240 136z"
                        />
                      </svg>
                    </span> Image galleries
                  </h3>
                  <p
                    class="text-size8 text-paragraph leading-spc3 font-medium mt-spc19 tracking-spc2"
                  >We've created a unique ‘gallery’ feature for image grids and carousels, making it easy to add these to your posts with some simple Liquid code.</p>
                </li>
                <li class="p-spc4">
                  <h3 class="flex items-center text-xl font-bold">
                    <span class="icon">
                      <svg
                        class="svg-inline--fa w-5 mr-3 text-primary fa-envelope fa-w-16"
                        aria-hidden="true"
                        data-prefix="far"
                        data-icon="envelope"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        data-fa-i2svg
                      >
                        <path
                          fill="currentColor"
                          d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"
                        />
                      </svg>
                    </span> Contact form
                  </h3>
                  <p
                    class="text-size8 text-paragraph leading-spc3 font-medium mt-spc19 tracking-spc2"
                  >Built-in contact form pop-up with Formspree integration for free form submissions.</p>
                </li>
                <li class="p-spc4">
                  <h3 class="flex items-center text-xl font-bold">
                    <span class="icon">
                      <svg
                        class="svg-inline--fa w-4 mr-3 text-primary fa-file-code fa-w-12"
                        aria-hidden="true"
                        data-prefix="far"
                        data-icon="file-code"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 384 512"
                        data-fa-i2svg
                      >
                        <path
                          fill="currentColor"
                          d="M369.941 97.941l-83.882-83.882A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-14.059-33.941zM332.118 128H256V51.882L332.118 128zM48 464V48h160v104c0 13.255 10.745 24 24 24h104v288H48zm101.677-115.115L116.854 320l32.822-28.885a8.793 8.793 0 0 0 .605-12.624l-17.403-18.564c-3.384-3.613-8.964-3.662-12.438-.401L62.78 313.58c-3.703 3.474-3.704 9.367.001 12.84l57.659 54.055a8.738 8.738 0 0 0 6.012 2.381 8.746 8.746 0 0 0 6.427-2.782l17.403-18.563a8.795 8.795 0 0 0-.605-12.626zm84.284-127.85l-24.401-7.084a8.796 8.796 0 0 0-10.905 5.998L144.04 408.061c-1.353 4.66 1.338 9.552 5.998 10.905l24.403 7.084c4.68 1.355 9.557-1.354 10.905-5.998l54.612-188.112c1.354-4.66-1.337-9.552-5.997-10.905zm87.258 92.545l-57.658-54.055c-3.526-3.307-9.099-3.165-12.439.401l-17.403 18.563a8.795 8.795 0 0 0 .605 12.625L267.146 320l-32.822 28.885a8.793 8.793 0 0 0-.605 12.624l17.403 18.564a8.797 8.797 0 0 0 12.439.401h-.001l57.66-54.055c3.703-3.473 3.703-9.366-.001-12.839z"
                        />
                      </svg>
                    </span> Markdown + code formatting
                  </h3>
                  <p
                    class="text-size8 text-paragraph leading-spc3 font-medium mt-spc19 tracking-spc2"
                  >Made has full markdown support, and built-in code highlighting to make sure your code samples look as great as the rest of your content.</p>
                </li>
                <li class="p-spc4">
                  <h3 class="flex items-center text-xl font-bold">
                    <span class="icon">
                      <svg
                        class="svg-inline--fa w-5 mr-3 text-primary fa-share-square fa-w-18"
                        aria-hidden="true"
                        data-prefix="far"
                        data-icon="share-square"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                        data-fa-i2svg
                      >
                        <path
                          fill="currentColor"
                          d="M561.938 158.06L417.94 14.092C387.926-15.922 336 5.097 336 48.032v57.198c-42.45 1.88-84.03 6.55-120.76 17.99-35.17 10.95-63.07 27.58-82.91 49.42C108.22 199.2 96 232.6 96 271.94c0 61.697 33.178 112.455 84.87 144.76 37.546 23.508 85.248-12.651 71.02-55.74-15.515-47.119-17.156-70.923 84.11-78.76V336c0 42.993 51.968 63.913 81.94 33.94l143.998-144c18.75-18.74 18.75-49.14 0-67.88zM384 336V232.16C255.309 234.082 166.492 255.35 206.31 376 176.79 357.55 144 324.08 144 271.94c0-109.334 129.14-118.947 240-119.85V48l144 144-144 144zm24.74 84.493a82.658 82.658 0 0 0 20.974-9.303c7.976-4.952 18.286.826 18.286 10.214V464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h132c6.627 0 12 5.373 12 12v4.486c0 4.917-2.987 9.369-7.569 11.152-13.702 5.331-26.396 11.537-38.05 18.585a12.138 12.138 0 0 1-6.28 1.777H54a6 6 0 0 0-6 6v340a6 6 0 0 0 6 6h340a6 6 0 0 0 6-6v-25.966c0-5.37 3.579-10.059 8.74-11.541z"
                        />
                      </svg>
                    </span> Social media icons
                  </h3>
                  <p
                    class="text-size8 text-paragraph leading-spc3 font-medium mt-spc19 tracking-spc2"
                  >We've built in social media icons for your favorite networks, making it easy to link to your external profiles.</p>
                </li>
                <li class="p-spc4">
                  <h3 class="flex items-center text-xl font-bold">
                    <span class="icon">
                      <svg
                        class="svg-inline--fa w-5 mr-3 text-primary fa-search-plus fa-w-16"
                        aria-hidden="true"
                        data-prefix="far"
                        data-icon="search-plus"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        data-fa-i2svg
                      >
                        <path
                          fill="currentColor"
                          d="M312 196v24c0 6.6-5.4 12-12 12h-68v68c0 6.6-5.4 12-12 12h-24c-6.6 0-12-5.4-12-12v-68h-68c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h68v-68c0-6.6 5.4-12 12-12h24c6.6 0 12 5.4 12 12v68h68c6.6 0 12 5.4 12 12zm196.5 289.9l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L347.5 387.1c-2.3-2.3-3.5-5.3-3.5-8.5v-13.2c-36.5 31.5-84 50.6-136 50.6C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 52-19.1 99.5-50.6 136h13.2c3.2 0 6.2 1.3 8.5 3.5l121.4 121.4c4.7 4.7 4.7 12.3 0 17zM368 208c0-88.4-71.6-160-160-160S48 119.6 48 208s71.6 160 160 160 160-71.6 160-160z"
                        />
                      </svg>
                    </span> SEO friendly
                  </h3>
                  <p
                    class="text-size8 text-paragraph leading-spc3 font-medium mt-spc19 tracking-spc2"
                  >We built Made with SEO best practices in mind, and a focus on fast page rendering.</p>
                </li>
                <li class="p-spc4">
                  <h3 class="flex items-center text-xl font-bold">
                    <span class="icon">
                      <svg
                        class="svg-inline--fa w-5 mr-3 text-primary fa-sliders-h-square fa-w-14"
                        aria-hidden="true"
                        data-prefix="far"
                        data-icon="sliders-h-square"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                        data-fa-i2svg
                      >
                        <path
                          fill="currentColor"
                          d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6zm-42-244v8c0 6.6-5.4 12-12 12H192v24c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24v-24h-20c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h20v-24c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v24h148c6.6 0 12 5.4 12 12zm0 128v8c0 6.6-5.4 12-12 12h-20v24c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24v-24H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h148v-24c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v24h20c6.6 0 12 5.4 12 12z"
                        />
                      </svg>
                    </span> Customize everything
                  </h3>
                  <p
                    class="text-size8 text-paragraph leading-spc3 font-medium mt-spc19 tracking-spc2"
                  >It's easy to change colors, spacing, fonts, sizes etc. via a simple settings file – you don't even need to touch the code.</p>
                </li>
                <li class="p-spc4">
                  <h3 class="flex items-center text-xl font-bold">
                    <span class="icon">
                      <svg
                        class="svg-inline--fa w-5 mr-3 text-primary fa-github fa-w-16"
                        aria-hidden="true"
                        data-prefix="fab"
                        data-icon="github"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 496 512"
                        data-fa-i2svg
                      >
                        <path
                          fill="currentColor"
                          d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
                        />
                      </svg>
                    </span> Works with GitHub Pages
                  </h3>
                  <p
                    class="text-size8 text-paragraph leading-spc3 font-medium mt-spc19 tracking-spc2"
                  >Host your site for free on GitHub Pages, no non-native plugins needed.</p>
                </li>
              </ul>

              <h3 class="text-size6 font-bold text-secondary leading-spc2">License and instructions</h3>
              <p
                class="bottom-desc xl:text-size5 text-size5 md:text-size8 font-medium text-paragraph leading-spc3 mt-spc6 tracking-spc2"
              >$49 gets you a license to use the theme for a single project or website. The full license is included with the theme files.</p>
              <p
                class="bottom-desc text-size5 font-medium text-paragraph leading-spc3 mt-spc6 tracking-spc2"
              >It comes with full documentation showing you how to set up and customize the theme and use all of it’s features.</p>

              <h3
                class="text-size6 font-bold text-secondary leading-spc2 mt-10"
              >Updated and supported by us</h3>
              <p
                class="bottom-desc xl:text-size5 text-size5 md:text-size8 font-medium text-paragraph leading-spc3 mt-spc6 tracking-spc2"
              >
                Made was created by the Jekyll Themes team exclusively for sale on this website. We keep our premium themes up to date with fixes and new features, and provide direct 1-to-1 support for all included features –
                <a
                  href="#"
                  class="font-bold text-secondary hover:text-primary"
                >just send us a message.</a>
              </p>

              <h3 class="text-size6 font-bold text-secondary leading-spc2 mt-10">Theme Tweaks</h3>
              <p
                class="bottom-desc xl:text-size5 text-size5 md:text-size8 font-medium text-paragraph leading-spc3 mt-spc6 tracking-spc2"
              >
                Getting stuck trying to make an important customization, adding that special personal touch or a feature that isn’t included?
                <a
                  href="#"
                  class="font-bold text-secondary hover:text-primary"
                >You can hire us</a> to complete a small custom task on this theme.
              </p>
            </div>
          </div>
          <div
            class="column theme-sidebar xl:px-spc7 px-spc7 md:px-5 xl:w-1/3 w-1/3 md:w-full xl:order-2 order-2 md:order-1"
          >
            <div
              class="theme-cta xl:sticky sticky md:relative xl:bg-transparent md:bg-white xl:p-0 md:pt-spc21 md:pr-spc7 md:pb-spc7 md:pl-spc7"
            >
              <div class="theme">
                <a
                  href="theme-single.html"
                  class="theme-img block overflow-hidden xl:block block md:hidden rp-none"
                >
                  <div class="theme-browser bg-whitelight2 h-6 flex items-center pl-2">
                    <span class="bg-white rounded-full w-2 h-2 mr-spc8"></span>
                    <span class="bg-white rounded-full w-2 h-2 mr-spc8"></span>
                    <span class="bg-white rounded-full w-2 h-2 mr-spc8"></span>
                  </div>
                  <div class="theme-screenshot">
                    <img :src="require('@/assets/images/pt-10.jpg')" alt="Theme" />
                  </div>
                </a>
                <div class="theme-content xl:mt-5 mt-5 md:mt-0">
                  <h1 class="flex items-center text-size6 font-bold relative pr-spc5">
                    <a href="theme-single.html" class="text-secondary hover:text-primary">Journal</a>
                    <span
                      class="theme-marker text-size7 bg-primary text-white uppercase tracking-spc2 leading-spc5 inline-block pt-1 pb-spc9 px-2 ml-spc10"
                    >made by us!</span>
                    <span
                      class="right absolute right-0 text-size5 font-light text-whitelight tracking-spc1"
                    >$49</span>
                  </h1>
                  <p class="text-base text-whitelight font-medium leading-spc3 flex items-center">
                    <span class="icon">
                      <svg
                        class="svg-inline--fa w-3 mr-3 fa-user fa-w-14"
                        aria-hidden="true"
                        data-prefix="far"
                        data-icon="user"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                        data-fa-i2svg
                      >
                        <path
                          fill="currentColor"
                          d="M313.6 304c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"
                        />
                      </svg>
                    </span> Created by
                    <a
                      href="#"
                      class="font-bold inline-block ml-1 hover:text-paragraph"
                    >Jekyll Themes</a>
                  </p>
                </div>
                <div class="theme-cta-buttons xl:mt-10 mt-10 md:mt-5 xl:block md:flex items-center">
                  <a
                    href="#"
                    class="theme-btn default-btn hover:border-secondary hover:bg-secondary"
                  >
                    <svg
                      class="svg-inline--fa inline-block w-5 mr-3 fa-shopping-cart fa-w-18"
                      aria-hidden="true"
                      data-prefix="far"
                      data-icon="shopping-cart"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 576 512"
                      data-fa-i2svg
                    >
                      <path
                        fill="currentColor"
                        d="M551.991 64H144.28l-8.726-44.608C133.35 8.128 123.478 0 112 0H12C5.373 0 0 5.373 0 12v24c0 6.627 5.373 12 12 12h80.24l69.594 355.701C150.796 415.201 144 430.802 144 448c0 35.346 28.654 64 64 64s64-28.654 64-64a63.681 63.681 0 0 0-8.583-32h145.167a63.681 63.681 0 0 0-8.583 32c0 35.346 28.654 64 64 64 35.346 0 64-28.654 64-64 0-18.136-7.556-34.496-19.676-46.142l1.035-4.757c3.254-14.96-8.142-29.101-23.452-29.101H203.76l-9.39-48h312.405c11.29 0 21.054-7.869 23.452-18.902l45.216-208C578.695 78.139 567.299 64 551.991 64zM208 472c-13.234 0-24-10.766-24-24s10.766-24 24-24 24 10.766 24 24-10.766 24-24 24zm256 0c-13.234 0-24-10.766-24-24s10.766-24 24-24 24 10.766 24 24-10.766 24-24 24zm23.438-200H184.98l-31.31-160h368.548l-34.78 160z"
                      />
                    </svg>
                    <span>
                      Buy Made
                      <em class="not-italic font-medium text-size1">for $49</em>
                    </span>
                  </a>
                  <div class="theme-demo-btn xl:mt-spc15 mt-spc15 md:mt-0 xl:ml-0 md:ml-4">
                    <a
                      href="#"
                      class="inline-block border-2 border-solid border-whitelight rounded-full font-bold text-size1 text-whitelight pt-spc1 pb-3 px-5 leading-none hover:text-secondary hover:border-secondary"
                    >
                      <svg
                        class="svg-inline--fa inline-block w-4 mr-3 fa-eye fa-w-18"
                        aria-hidden="true"
                        data-prefix="far"
                        data-icon="eye"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                        data-fa-i2svg
                      >
                        <path
                          fill="currentColor"
                          d="M569.354 231.631C512.97 135.949 407.81 72 288 72 168.14 72 63.004 135.994 6.646 231.631a47.999 47.999 0 0 0 0 48.739C63.031 376.051 168.19 440 288 440c119.86 0 224.996-63.994 281.354-159.631a47.997 47.997 0 0 0 0-48.738zM288 392c-102.556 0-192.091-54.701-240-136 44.157-74.933 123.677-127.27 216.162-135.007C273.958 131.078 280 144.83 280 160c0 30.928-25.072 56-56 56s-56-25.072-56-56l.001-.042C157.794 179.043 152 200.844 152 224c0 75.111 60.889 136 136 136s136-60.889 136-136c0-31.031-10.4-59.629-27.895-82.515C451.704 164.638 498.009 205.106 528 256c-47.908 81.299-137.444 136-240 136z"
                        />
                      </svg>
                      <span>Live Demo</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </main>
</template>

<script>
import Header from "../components/common/Header";
import carousel from "vue-owl-carousel";
import Footer from "../components/common/Footer";
export default {
  name: "ProductSingle",
  components: {
    Footer,
    carousel,
    Header
  }
};
</script>

<style>
.gallery-slider .owl-stage-outer {
  overflow: visible !important;
}
</style>